<template>
  <div>
    <div class="fl-sym-mt-2 fl-sym-max-w-sm fl-sym-mx-auto">
      <div class="fl-sym-px-7 first-card-header fl-sym-text-xs  fl-sym-text-white fl-sym-p-2">
        <div class="fl-sym-inline-block fl-sym-mt-1 fl-sym-text-white">
          <img src="@/assets/Info-blue.png" width="13" class="info-icon-white fl-sym-mr-1"/>
        </div>

        <div class="fl-sym-inline-block fl-sym-ml-1 fl-sym-letter-space-050 fl-sym-uppercase pet-name">{{pet.name}}’S SIGNALMENT</div>
        <div class="fl-sym-inline-block fl-sym-ml-4 fl-sym-letter-space-050 fl-sym-float-right date"><span class="Line">|</span> {{getCurrentDate(new Date())}}</div>
      </div>
      <div class="fl-sym-bg-white fl-first-card-body">
        <div class="fl-sym-flex">
          <div class="fl-sym-p-4 pet-div">
            <div v-if="pet.type=='Dog'">
              <img src="@/assets/dog-icon.svg" width="40" class="animal-icons"/>
              <div class="fl-sym-text-center">Dog</div>
            </div>
            <div v-if="pet.type=='Cat'">
              <img src="@/assets/cat-icon.svg" width="40" class="animal-icons"/>
              <div class="fl-sym-text-center">Cat</div>

            </div>
          </div>
      <div class="details">
          <div class="fl-sym-mx-4 fl-sym-mt-2 fl-sym-mb-2 fl-sym-border-left">
            <div class="fl-sym-ml-4">
            <div class="fl-sym-mt-1 fl-sym-text-lg">

              <span class="fl-sym-text-lg fl-sym-text-phd fl-sym-font-bold">Breed: </span>{{pet.breed}}
            </div>
            <div class="fl-sym-mt-1 fl-sym-text-phd fl-sym-text-lg">
              <span class="fl-sym-text-lg fl-sym-font-bold">Sex: </span>{{pet.sex}}
            </div>
            <div class="fl-sym-mt-1 fl-sym-text-phd fl-sym-text-lg">
              <span class="fl-sym-text-lg fl-sym-font-bold">DOB: </span>{{dateToYMD(pet.dob)}}
            </div>
            <div class="fl-sym-mt-1 fl-sym-text-phd fl-sym-text-lg">
              <span class="fl-sym-text-lg fl-sym-font-bold">Age: </span>{{age(pet.dob)}}
            </div>
            <div class="fl-sym-mt-1 fl-sym-text-phd fl-sym-text-lg">
              <span class="fl-sym-text-lg fl-sym-font-bold">Weight: </span>{{pet.weight}} kg
            </div>

            </div>

          </div>
          <div class="edit-div">
             <router-link class="link" :to="{ name: 'pet-edit' }">
          <img src="@/assets/pen-icon.svg" width="17" class="pen-icon"/>
          <p class="fl-sym-uppercase fl-sym-text-dark-blue edit-text">Tap to edit</p>
             </router-link>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    priority: {
      type: Number,
      default: 1,
    },
    pet: {
      type: Object,
      default: () => {
        return {
          name: "Jacky",
          type: "Dog",
          breed: "Labrador",
          sex: "Female",
          dob: new Date("2010-03-25"),
          weight: 31.3,
        }
      },
    },
  },
  methods: {
    getCurrentDate(date) {
      var strArray=['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'];
        var d = date.getDate();
        var m = strArray[date.getMonth()];
        var y = date.getFullYear();
        return '' + (d <= 9 ? '0' + d : d) + ' ' + m + ' ' + y;
    },
    dateToYMD(date) {
      var strArray = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ]
      var d = date.getDate()
      var m = strArray[date.getMonth()]
      var y = date.getFullYear()
      return "" + (d <= 9 ? "0" + d : d) + "-" + m + "-" + y
    },
    age(birthday) {
      // birthday is a date
      var ageDifMs = Date.now() - birthday.getTime()
      var ageDate = new Date(ageDifMs) // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970)
    },
  },
}
</script>
<style scoped>
.priority-1 {
  background: transparent linear-gradient(180deg, #5baa00 0%, #96d90be6 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
}
.priority-2 {
  background: transparent linear-gradient(0deg, #fab83be6 0%, #ff7f00 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
}
.priority-3 {
  background: transparent linear-gradient(180deg, #ffcc00 0%, #ffd427e6 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
}
.my-title {
  font: var(--unnamed-font-style-normal) normal
    var(--unnamed-font-weight-normal) var(--unnamed-font-size-12) /
    var(--unnamed-line-spacing-16)
    var(--unnamed-font-family-sfprodisplay-regular);
  letter-spacing: var(--unnamed-character-spacing-0-8);
  text-align: left;
  font: normal normal normal 12px/16px SFProDisplay-Regular;
  letter-spacing: 0.8px;
  color: #ffffffcc;
  opacity: 1;
}

.fl-first-card-body {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 14px 40px #29375426;
  border-radius: 7px;
  opacity: 1;
}

.fl-content {
  font: var(--unnamed-font-style-normal) normal
    var(--unnamed-font-weight-normal) var(--unnamed-font-size-17) /
    var(--unnamed-line-spacing-20)
    var(--unnamed-font-family-sfprodisplay-regular);
  letter-spacing: var(--unnamed-character-spacing-0-56);
  color: var(--unnamed-color-424747);
  text-align: left;
  font: normal normal normal 17px/20px SFProDisplay-Regular;
  letter-spacing: 0.56px;
  color: #424747;
}

.fl-dog {
  letter-spacing: var(--unnamed-character-spacing--0-16);
  color: var(--unnamed-color-424747);
  text-align: center;
  letter-spacing: -0.16px;
  color: #424747;
  opacity: 1;
}

.first-card-header {
  background: var(--unnamed-color-424747) 0% 0% no-repeat padding-box;
  background: #424747 0% 0% no-repeat padding-box;
  opacity: 1;
  height: fit-content;
    display: flow-root;
  border-radius: 14px 14px 0px 0px;
  opacity: 1;
}

.fl-border-right {
  border-right: 2px solid #6f7878;
}
.back-btn {
  color: var(--progress-bar-filler);
  text-align: center;
  letter-spacing: 0.64px;
  color: #00c5e3;
  opacity: 1;
}

.email-password {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 2px solid var(--unnamed-color-707070);
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 2px solid #707070;
  opacity: 1;
}

.fym-btn-text {
  color: var(--progress-bar-filler);
  text-align: center;
  letter-spacing: 0.64px;
  color: #00c5e3;
  opacity: 1;
}

.fym-p {
  letter-spacing: var(--unnamed-character-spacing-0-8);
  color: var(--unnamed-color-ffffff);
  text-align: left;
  letter-spacing: 0.8px;
  color: #ffffff;
  opacity: 1;
}

.fl-tag {
  letter-spacing: 0;

  text-align: center;
  letter-spacing: 0px;
  color: #6f7878;
  border: 2px solid #999999;

  opacity: 1;
}

.my-heading-header {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    var(--unnamed-font-size-28) / var(--unnamed-line-spacing-32)
    var(--unnamed-font-family-sf-pro-display);
  letter-spacing: var(--unnamed-character-spacing--0-16);
  color: var(--unnamed-color-ffffff);
  text-align: left;
  font: normal normal bold 28px/32px SF Pro Display;
  letter-spacing: -0.16px;
  color: #ffffff;
  opacity: 1;
}

.fl-title {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    var(--unnamed-font-size-17) / var(--unnamed-line-spacing-20)
    var(--unnamed-font-family-sf-pro-display);
  color: var(--unnamed-color-373d42);
  text-align: left;
  font: normal normal bold 17px/20px SF Pro Display;
  letter-spacing: -0.1px;
  color: #373d42;
}

.info-icon-white{
  filter: brightness(3);
}
.pet-name {
  position:relative;
}
.date {
  margin-right: 6px;
 }
.date, .info-icon-white{
  position:relative;
  bottom: -1px;
}
span.Line {
    font-size: 17px;
    font-family: 'SF Pro Display Light';
}
.fl-sym-border-left{
  border-left: 1px solid #e2e8f0;
}
.pet-div {
  margin: auto 0px;
}
.animal-icons {
  filter: brightness(0.7);
}
.details {
    width: 90%;
}
.edit-text {
  font-size: 5px;
  letter-spacing: 0.16px;
  line-height: 22px;
  position: relative;
  bottom: 5px;
}
.edit-div {
    float: right;
    margin-right: 20px;
    display: inline;
    margin-top: -30px;
}
.pen-icon {
  margin: auto;
}
</style>
